import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 0C2.01472 0 0 2.01472 0 4.5C0 6.98528 2.01472 9 4.5 9C6.98528 9 9 6.98528 9 4.5C9 2.01472 6.98528 0 4.5 0Z",
			fill: "#111111"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 0C13.0147 0 11 2.01472 11 4.5C11 6.98528 13.0147 9 15.5 9C17.9853 9 20 6.98528 20 4.5C20 2.01472 17.9853 0 15.5 0Z",
			fill: "#111111"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 11C2.01472 11 0 13.0147 0 15.5C0 17.9853 2.01472 20 4.5 20C6.98528 20 9 17.9853 9 15.5C9 13.0147 6.98528 11 4.5 11Z",
			fill: "#111111"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 11C13.0147 11 11 13.0147 11 15.5C11 17.9853 13.0147 20 15.5 20C17.9853 20 20 17.9853 20 15.5C20 13.0147 17.9853 11 15.5 11Z",
			fill: "#111111"
		})
	]
});
const ForwardRef = forwardRef(SvgGridFilled);
export default ForwardRef;
